import React, { createContext, useContext, useState, useEffect } from 'react';
import io from 'socket.io-client';

import { SERVER_URL } from '../../config/env';

const SocketContext = createContext(null);

export const useSocket = () => {
    const context = useContext(SocketContext);
    if (context === undefined) {
        throw new Error('useSocket must be used within a SocketProvider');
    }
    // Return the socket instance directly, or potentially an object with more helpers later
    return context.socket;
};

export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        const newSocket = io(SERVER_URL, {
            transports: ['websocket'],
        });
        window.socket = newSocket;
        setSocket(newSocket);

        console.log('Attempting to connect to socket server...');

        newSocket.on('connect', () => {
            console.log('Socket connected:', newSocket.id);
        });

        newSocket.on('disconnect', (reason) => {
            console.log('Socket disconnected:', reason);
            // Optional: Implement reconnection logic here if desired
        });

        newSocket.on('connect_error', (error) => {
            console.error('Socket connection error:', error);
        });

        return () => {
            console.log('Disconnecting socket...');
            newSocket.disconnect();
            setSocket(null);
        };
    }, []);

    const value = {
        socket,
        isConnected: socket?.connected ?? false
    };

    return (
        <SocketContext.Provider value={value}>
            {children}
        </SocketContext.Provider>
    );
};

export default SocketContext; 